module.exports = __webpack_public_path__ + "93cf8107f6d39a09b17f74ddefe45e62.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-to-hang-out-after-school/CoffeeShop2.jpg
// module id = 3368
// module chunks = 0